<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked " class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<!-- MAIN SCREEN -->
<div class="card" *ngIf="translations && globalUserPreferences?.storeId != null">

    <!-- GO BACK BUTTON -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <!-- FORM -->
                <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12" [formGroup]="globalUserDataForm">

                    <!-- INPUT COORDINATION-->
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_coordination}}</span>
                        <span class="p-text-bold">{{globalUserDataForm.get('selectedCoordination').value}}</span>
                    </div>

                    <!-- INPUT LANGUAGE
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_language}}</span>
                        <span class="p-text-bold">{{globalUserDataForm.get('selectedLanguage').value?.value}}</span>
                    </div> -->

                    <!-- INPUT CURRENCIES -->
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_currency}}</span>
                        <span class="p-text-bold">{{globalUserDataForm.get('selectedCurrency').value?.value}}</span>
                    </div>

                    <!-- INPUT CONCEPT -->
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_concept}}</span>
                        <span class="p-text-bold">{{globalUserDataForm.get('selectedConcept').value}}</span>
                    </div>

                    <!-- INPUT DESTINY -->
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_destination}}</span>
                        <span class="p-text-bold">{{globalUserDataForm.get('selectedUnit').value}}</span>
                    </div>

                    <!-- INPUT DATE -->
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_date}}</span>
                        <div class="p-col-12 p-md-8">
                            <p-calendar formControlName="selectedDate" [touchUI]="true" [readonlyInput]="true"
                                inputId="touchui" [showIcon]="true" dateFormat="dd-mm-yy" [disabled]="false"
                                [minDate]="globalUserDataForm.get('selectedMinDate').value"
                                [maxDate]="globalUserDataForm.get('selectedMaxDate').value"
                                (onClose)="onChangeUserPreferences()"></p-calendar>
                        </div>
                    </div>
                </div>
            </p-panel>
        </div>
    </div>

    <br />
    <!-- TAB VIEW -->
    <p-tabView>

        <!-- TAB PANEL CXC -->
        <p-tabPanel [header]="getTabHeader()">
            <p-table emptyMessage="Registros no existentes" #dt2 [columns]="cols" [value]="dataI"
                [rows]="40" [showCurrentPageReport]="false"  responsive="true">

                <!-- CAPTION -->
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-left p-jc-between responsive">
                        <div>
                            <button type="button" pButton pRipple icon="pi pi-file-excel"
                                (click)="exportExcel(dataI,colsFiI,'recPay')" class="p-button-success p-m-2 z-5"
                                pTooltip="XLS" tooltipPosition="bottom"></button>

                            <button type="button" pButton pRipple icon="pi pi-file-pdf"
                                (click)="exportPdf(dataI,colsFiI,'recPay')" class="p-button-warning p-m-2"
                                pTooltip="PDF" tooltipPosition="bottom"></button>

                            <button *ngIf="this.dataParent.type && this.dataParent.type === 'AR'" pButton pRipple
                                type="button" icon="pi pi-plus" class="p-button-raised p-m-2 z-5"
                                [disabled]="globalUserPreferences.preferences.levelId == 'L'"
                                pTooltip="Nuevo Registro" (click)="redirectToRecPay('CREATE', null)"></button>

                            <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-m-2 z-5"
                                (click)="reloadGetListIncome()"></button>
                        </div>

                        <div class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt2.filterGlobal($event.target.value, 'contains')"
                                placeholder="{{translations.lbl_search}}..." />
                        </div>
                    </div>
                </ng-template>

                <!-- HEADER -->
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <ng-container *ngFor="let col of columns">
                            <th 
                            
                            pTooltip="{{ col.header }}" 
                            [ngClass]="{
                                'text-right': col.type == 'float'
                            }">
                                {{ capitalizeLastElement(col.header) }}
                                
                            </th>
                        </ng-container>
                        <th class="coordName-nowrap text-right">{{translations.lbl_actions}}</th>
                    </tr>
                </ng-template>

                <!-- BODY -->
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{
                            'text-right': isNumeric(rowData[col.field])
                        }">
                            <span class="p-column-title">{{col.header}}</span>
                            {{ getNestedValue(rowData, col.field) }}
                        </td>
                        <td class="coordName-nowrap text-right">
                            <button *ngIf="(rowData.status === 'N' && rowData.sequence != null)" pButton pRipple icon="pi pi-pencil"
                                class="p-button-rounded p-button-warning p-mr-2"
                                [disabled]="globalUserPreferences.preferences.levelId == 'L'"
                                (click)="redirectToRecPay('UPDATE', rowData)"></button>

                            <button *ngIf="rowData.menuOption == 'TRF2' || rowData.menuOption == 'OR8'"  type="button" pButton pRipple icon="pi pi-file-excel"
                                (click)="dwnRemitionXls(rowData)" class="p-button-success p-m-2 z-5" label="{{getDownloadLabel(rowData.dwdDocum)}}"
                                pTooltip="XLS" tooltipPosition="bottom"></button>
                        </td>
                    </tr>

                </ng-template>

                <!-- EMPTY -->
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>

                        <td [attr.colspan]="columns ? columns.length : 9">
                            No se encontraron registros en la consulta solicitada.
                        </td>
                    </tr>
                </ng-template>

                <!-- SUMMARY -->
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{translations.lbl_there_are}} {{dataI.length > 0 ? dataI.length - 1 : 0 }}
                        {{translations.lbl_records}}.
                    </div>
                </ng-template>
            </p-table>
        </p-tabPanel>
    </p-tabView>
</div>

<!-- OVERLAY SCREEN NO STORE ID -->
<div *ngIf="globalUserPreferences?.storeId == null" class=" overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">Verifica sesión e intenta mas tarde ... </span>
</div>